import { inject } from 'mobx-react';
import * as React from 'react';
import { PropertySearchLink } from '@shared-ui/lodging-property-offers';
import { withSharedUiPropertyOffers } from './shared-ui-property-offers';
const PropertySearchLinkWrapper = inject('currentHotel')(({
  currentHotel,
  inputs
}) => React.createElement(PropertySearchLink, {
  inputs: inputs,
  skipSsr: true,
  isNavigationFromSRP: currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.isNavigationFromSRP,
  showLinkLabel: true
}));
PropertySearchLinkWrapper.displayName = 'SharedUiPropertySearchLinkWrapper';
export const SharedUiPropertySearchLinkWrapper = withSharedUiPropertyOffers(PropertySearchLinkWrapper);